/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Tracks_TitleInputs */



/**
* | output |
* | --- |
* | "Caption tracks" |
*
* @param {Subtitle_Extract_Tracks_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_tracks_title = /** @type {((inputs?: Subtitle_Extract_Tracks_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Tracks_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelspuren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tracce di sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pistas de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕トラック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन ट्रैक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas")
	return /** @type {LocalizedString} */ ("Caption tracks")
});